import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpService } from './http.service';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(public hs: HttpService, public gs: GlobalService) { }
  async login_user(value: any) {
    try {
      delete value.id;
      let response = await this.hs.post('/user/log-in', {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async send_otp(value: any) {
    try {
      delete value.id;
      let response = await this.hs.post('/user/forgot-password', {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async verify_otp(value: any) {
    try {
      let response = await this.hs.post('/auth/verify-otp', {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async update_password(value: any) {
    try {
      let response = await this.hs.post('/user/reset-password', {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async logout(value: any) {
    try {
      let response = await this.hs.post('/user/log-out', {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async aadhaar_check_status(value: { request_id: string }) {
    try {
      let response = await this.hs.post('/auth/aadhaar/check-status', {}, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async upload_image(image_base64: string, token: string): Promise<string> {
    const fetch_res = await fetch(image_base64);
    const blob = await fetch_res.blob();
    const file = new File([blob], `face-${Date.now()}.jpeg`, { type: 'image/jpeg' });
    const form = new FormData();
    form.append('file', file);
    const response: any = await firstValueFrom(
      this.hs.http.post(
        this.hs.base_url + '/media/upload',
        form,
        { headers: { Authorization: `Bearer ${token}` } }
      )
    );
    if (!response?.file_path) throw new Error('Upload failed');
    return response.file_path;
  }

  async face_register(image_path: string, token: string) {
    try {
      const response: any = await firstValueFrom(
        this.hs.http.post(
          this.hs.base_url + '/auth/face-verification/register',
          { image_path },
          { headers: { Authorization: `Bearer ${token}` } }
        )
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async face_verify(image_path: string, token: string) {
    try {
      const response: any = await firstValueFrom(
        this.hs.http.post(
          this.hs.base_url + '/auth/face-verification/verify',
          { image_path },
          { headers: { Authorization: `Bearer ${token}` } }
        )
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async face_request_approval(image_path: string, token: string) {
    try {
      const response: any = await firstValueFrom(
        this.hs.http.post(
          this.hs.base_url + '/auth/face-verification/request-approval',
          { image_path },
          { headers: { Authorization: `Bearer ${token}` } }
        )
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
